/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import useSnackbar from 'src/hooks/useCustomSnackbar';
// @mui
import {
    Card,
    Typography,
    Stack,
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    Popper,
    Paper,
    Grow,
    MenuList,
    MenuItem,
    Radio,
    Zoom,
    Tooltip,
    ListItem,
    List,
    ListItemAvatar,
    ListItemText,
    useTheme,
    ClickAwayListener,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// Components
import { fetchMergeTagValueForLeads, fetchMergeTagValueForTreatments } from 'src/redux/slices/mergeTags';
import { initializeFacebookAuthToken } from 'src/redux/slices/whatsapp';
import useWindowSize from 'src/hooks/windowSizeListner';
import Activities from './Activities';
import TreatmentEditPopover from '../../../pages/dashboard/tables/AllLeadTable/TreatmentEditPopover';
import ClinCheckOverViewTab from '../../../components/clinCheck/ClinCheckOverViewTab';
import { Iconify } from '../../../components';
import { AttendedAppointment } from '../../../components/Attended';
import { CustomAvatar, AssignUserAvatar } from '../../../components/custom-avatar';
import { UnableToContact } from '../../../components/failedToAttendTabs';
import UpcomingAppointmentsOverview from '../../../components/UpcomingAppointmentsOverview';
import RecentNotes from '../../../components/RecentNotes';
import RecentAttachments from '../../../components/RecentAttachments';
import SimilarLeadWarningPopup from './SimilarLeadWarningPopup';
import {
    OpenConsultationPopup,
    OpenAttendedPopup,
    OpenUnAttendedPopup,
    OpenContactLeadPopup,
} from '../../../components/fullScreenPopUps';
import {
    AssignTaskPopup,
    ArchivedLeadPopUp,
    EditPersonalDetailsPopup,
    AppointmentAssignTaskPopup
} from '../../../components/dialogPopUp';
import { NormalLoading } from '../../../components/loading';
import LeadTemplate from '../../../pages/dashboard/LeadTemplate';
import { FollowUp, AppointmentPage } from '../lead';
import { flwBtnStyle } from '../../../styles/NewLeadTableRowStyle';
import {
    TreatmentAndAppointment,
    PersonalDetails,
    PaymentOption,
    MessageAndReminder
} from '../general/app';
import { DentallyPaymentConfirmation, DentallyPendingBookingBanner, DentallyTreatmentAvailabilityWizardStep, DentallyFollowUpConfirmWizardStep, BookingModeToggle } from '../../../components/dentally';
import { PmsAvailabilityWizardStep, PmsBookingConfirmStep } from '../../../components/pms';
import { syncDentallyAppointment } from '../../../utils/syncDentallyAppointment';
import { deleteDentallyAppointment } from '../../../utils/dentallyApi';
import { ReusableSidebar } from '../calendar';
import AttendedAppointmentsOverview from '../../../components/AttendedAppointmentsOverview';
// redux
import { setCurrentTreatmentDataGlobal } from '../../../redux/slices/multiTreatment';
import { getActivities } from '../../../redux/slices/activity';
import { updateSelectedSimilarLeads } from '../../../redux/slices/duplicateLeads';
import { dispatch, useSelector } from '../../../redux/store';
import {
    selectFollowLead,
} from '../../../redux/selectors/leadSelectors';
import {
    clearLead,
    updateSteps,
    updateBookingSteps,
    followUpAppointmentHandler,
    updateFollowUpLead,
    updateLeadDetail,
    ConsultationAttended,
    RecordAttended,
    recordUnAttended,
    getLeadReminderData,
    CompleteTreatment,
    followUpSlice,
    deleteTreatment,
    tableLead,
    getAppointment,
    startLoadingData,
    getLeadNotes,
    updateReminder,
    getReminderData,
    getLeadNotesWithFilter,
    patchLeadMetadata
} from '../../../redux/slices/lead';
import { clearPracticeUserData } from '../../../redux/slices/practiceUser';
import { switchPractice } from '../../../redux/slices/practiceTreatmentList';
// §9 MUST FE — V2 task thunks for the upcoming-task strip + row actions.
import { completeTask, reopenTask } from '../../../redux/slices/taskSlice';
import useFeaturePermission from '../../../hooks/useFeaturePermission';
import { setLoader } from '../../../redux/slices/loader';
// utils/constant/hooks
import { getTreatmentDetails, handleSetTreatmentDataGlobal } from '../../../utils/multiTreatmentFlow';
import capitalizeFirstLetter from '../../../utils/capitalizedFunc';
import { setLeadSourceIcon } from '../../../utils/timelineIcon';
import { getMessage } from '../../../utils/getTasksData';
import { GetPracticeAvatar } from '../../../utils/createAvatar';
import { setRowLeadData } from '../../../utils/getRowLeadData';
import { getAssignees } from '../../../utils/multiAsignees';
import { TAB_HEAD, statuses, JOURNEY_STAGES, getStageIndex, NEXT_STEP_SUGGESTIONS } from '../../../constants/LeadDetailConst';
import {
    useArchivedToggle,
    useConsultationAttendToggle,
    useRecordAttendToggle,
    useUnRecordAttendToggle,
    useToggle,
    useResponsive,
    useAssignTaskToggle,
    useAddTreatment,
    useLeadTableHelper,
} from '../../../hooks';
import { localStorageRemoveItem } from '../../../utils/storage-available';
// styles
import { common, grey } from '../../../theme/palette';
import {
    infoIconBox,
    overViewCard,
    overViewDynamicOuterBox,
    paperStyle,
    timeLabel,
    avatarBox,
    avatarInnerBox,
    plusIconBox,
    unassignTypo,
    menuListStyle,
    cancelBtnStyle,
    unassignedBoxStyle,
    messageBox,
    takeDepositButton,
    overviewMainBoxStyle,
    overviewLeftLayoutBoxStyle,
    overviewRightLayoutBoxStyle,
    leadAppointmentCardStyle,
    lockIconMainBoxStyle,
    lockIconInnerBoxStyle,
    priceValueTextStyle,
    statusStyle,
    finalTreatmentBoxStyle,
    dotsIconBoxStyle,
    nextStepCard,
    nextStepIcon,
    nextStepTitle,
    nextStepDescription,
    nextStepCTA,
    treatmentProgressCard,
    treatmentCardHeader,
    treatmentNameStyle,
    treatmentPriceStyle,
    miniStepperWrapper,
    miniStepDot,
    miniStepConnector,
    timelineFilterWrapper,
    timelineFilterChip,
    sectionTitle,
} from '../../../styles/OverView';
import {
    paperMenuItem,
    editDetailMenuItem,
    menuItemIcon,
    overViewMenuItemStyle,
    typoSpanStyle,
    appointmentCardStyle
} from '../../../styles/LeadDetailView';
import { taskButton, archivedButton, textStyle, assignUserAvatarStyle, assignLengthStyle } from '../../../styles/leadTaskReminder';
import { yesBtnStyleForLoader } from '../../../styles/Common';
import 'swiper/css';
import 'swiper/css/navigation';
import TaskChecklistCard from './TaskChecklistCard';
import AttendedChecklistV2 from './AttendedChecklistV2';

// Helper function to check if a note is an AI note
const parseAINote = (noteContent) => {
    if (!noteContent) return null;
    try {
        const parsed = JSON.parse(noteContent);
        if (parsed && parsed.AI_NOTES === true) {
            return parsed;
        }
    } catch (e) {
        // Not a JSON note, return null
    }
    return null;
};

// Helper function to get display text for notes (handles AI notes)
const getNoteDisplayText = (noteContent) => {
    const aiData = parseAINote(noteContent);
    if (aiData) {
        return '🤖 AI Call Summary - Click to view in lead details';
    }
    return capitalizeFirstLetter(noteContent);
};

// ── Overview activity preview helpers ─────────────────────────────────────
// Mirror the lead-detail Timeline tab look so the preview card stays consistent.
// NOTE: hex literals (not palette tokens) — these colours flow through string
// interpolations like `${color}1F` for soft-tinted backgrounds, which require
// a 6-char hex; theme tokens such as `success.main` won't resolve there.
const OVERVIEW_VERB_CONFIG = {
    created: { icon: 'solar:user-plus-bold', color: '#00A76F' },
    treatment_added: { icon: 'solar:teeth-bold', color: '#078DEE' },
    treatment_started: { icon: 'solar:teeth-bold', color: '#00A76F' },
    lead_treatment_status_transitioned: { icon: 'eva:swap-fill', color: '#FFAB00' },
    note_added: { icon: 'solar:pen-bold', color: '#FF5630' },
    message_sent: { icon: 'ic:round-email', color: '#078DEE' },
    message_failed: { icon: 'ic:round-email', color: '#FF5630' },
    whatsapp_message_sent: { icon: 'ic:baseline-whatsapp', color: '#25D366' },
    whatsapp_message_failed: { icon: 'ic:baseline-whatsapp', color: '#FF5630' },
    appointment_added: { icon: 'solar:calendar-bold', color: '#5119B7' },
    appointment_attended: { icon: 'eva:checkmark-circle-2-fill', color: '#00A76F' },
    appointment_cancelled: { icon: 'eva:close-circle-fill', color: '#919EAB' },
    appointment_rescheduled: { icon: 'solar:calendar-bold', color: '#FFAB00' },
    lead_archived: { icon: 'mdi:archive-outline', color: '#919EAB' },
    lead_payment_initiated: { icon: 'solar:wallet-money-bold', color: '#00A76F' },
    default: { icon: 'solar:bell-bold', color: '#919EAB' },
};

const getOverviewActivityIcon = (act) => {
    const verb = act?.verb;
    if (verb === 'note_added') {
        const noteType = act?.action_object?.note;
        const via = act?.action_object?.contacted_via;
        if (noteType === 'UNABLE_TO_CONTACT') return { icon: 'solar:phone-calling-bold', color: '#FF5630' };
        if (via === 'PHONE') return { icon: 'fluent:call-20-filled', color: '#00A76F' };
        if (via === 'WHATSAPP') return { icon: 'ic:baseline-whatsapp', color: '#25D366' };
        if (via === 'EMAIL') return { icon: 'ic:round-email', color: '#078DEE' };
        if (via === 'SMS') return { icon: 'bi:chat-left-dots-fill', color: '#7635DC' };
        if (noteType === 'FOLLOW_UP') return { icon: 'mdi:clock-time-three-outline', color: '#FFAB00' };
        if (noteType === 'AWAITING_RESPONSE') return { icon: 'mdi:clock-time-three-outline', color: '#078DEE' };
        return { icon: 'solar:pen-bold', color: '#637381' };
    }
    if (verb === 'message_sent') {
        const ao = act?.action_object;
        const isAuto = ao?.message_group === 'SYSTEM' || ao?.message_category === 'SEQUENCE_MESSAGE';
        if (isAuto) return { icon: 'mdi:email-fast-outline', color: '#919EAB' };
        return { icon: 'ic:round-email', color: '#078DEE' };
    }
    return OVERVIEW_VERB_CONFIG[verb] || OVERVIEW_VERB_CONFIG.default;
};

const OVERVIEW_ENGAGEMENT_LABELS = {
    delivered: 'Delivered', opened: 'Opens', clicked: 'Clicks', bounced: 'Bounced', unsubscribed: 'Unsubscribed',
};

const getOverviewEmailStatus = (act) => {
    if (act?.verb !== 'message_sent' && act?.verb !== 'message_failed') return null;
    if (act?.action_object?.type !== 'EMAIL') return null;
    if (act?.action_object?.message_category === 'NOTIFICATION') return null;
    if (act.verb === 'message_failed') return { label: 'Failed', color: '#FF5630', icon: 'eva:close-circle-fill' };
    const counts = {};
    (act?.action_object?.sent_messages || []).forEach((sm) => {
        (sm?.event_counts || []).forEach((ec) => {
            if (ec?.event && ec?.count) counts[ec.event] = (counts[ec.event] || 0) + ec.count;
        });
    });
    if (counts.bounced) return { label: 'Bounced', color: '#FF5630', icon: 'solar:close-circle-bold', counts };
    if (counts.unsubscribed) return { label: 'Unsubscribed', color: '#919EAB', icon: 'mdi:bell-off-outline', counts };
    if (counts.clicked) return { label: counts.clicked > 1 ? `${counts.clicked} Clicks` : 'Clicked', color: '#00A76F', icon: 'solar:cursor-bold', counts };
    if (counts.opened) return { label: counts.opened > 1 ? `${counts.opened} Opens` : 'Opened', color: '#3b82f6', icon: 'solar:eye-bold', counts };
    if (counts.delivered) return { label: 'Delivered', color: '#919EAB', icon: 'eva:done-all-fill', counts };
    const isAuto = act?.action_object?.message_group === 'SYSTEM' || act?.action_object?.message_category === 'SEQUENCE_MESSAGE';
    if (isAuto) return { label: 'Auto', color: '#C4CDD5', icon: 'mdi:robot-outline' };
    return { label: 'Sent', color: '#919EAB', icon: 'mdi:check' };
};

const OVERVIEW_WHATSAPP_STATUS = {
    read: { label: 'Read', color: '#078DEE', icon: 'eva:done-all-fill' },
    delivered: { label: 'Delivered', color: '#919EAB', icon: 'eva:done-all-fill' },
    sent: { label: 'Sent', color: '#C4CDD5', icon: 'mdi:check' },
    failed: { label: 'Failed', color: '#FF5630', icon: 'eva:close-fill' },
};

const getOverviewWhatsAppStatus = (act) => {
    if (act?.verb === 'whatsapp_message_failed') return { label: 'Failed', color: '#FF5630', icon: 'eva:close-circle-fill' };
    if (act?.verb !== 'whatsapp_message_sent') return null;
    return OVERVIEW_WHATSAPP_STATUS[act?.action_object?.status || 'sent'] || OVERVIEW_WHATSAPP_STATUS.sent;
};

const buildOverviewStatusTooltip = (status) => {
    if (!status?.counts) return status?.label || '';
    return Object.entries(OVERVIEW_ENGAGEMENT_LABELS)
        .filter(([k]) => status.counts[k])
        .map(([k, label]) => `${status.counts[k]} ${label}`)
        .join(' · ');
};

const OVERVIEW_TS_FORMATS = [
    'DD-MM-YYYY HH:mm:ss.SSSSSSZ',
    'DD-MM-YYYY HH:mm:ss.SSSZ',
    'DD-MM-YYYY HH:mm:ssZ',
    'DD-MM-YYYY HH:mm:ss',
    'DD-MM-YYYY',
    moment.ISO_8601,
];

const formatOverviewActivityTime = (timestamp) => {
    const m = moment(timestamp, OVERVIEW_TS_FORMATS);
    if (!m.isValid()) return '';
    const now = moment();
    const diffHours = now.diff(m, 'hours');
    const diffDays = now.diff(m.clone().startOf('day'), 'days');
    if (diffHours < 24 && diffDays === 0) return m.fromNow();
    if (diffDays === 1) return `Yesterday at ${m.format('h:mm a')}`;
    if (diffDays > 1 && diffDays <= 6) return `${m.format('dddd')} at ${m.format('h:mm a')}`;
    if (m.year() === now.year()) return m.format('DD MMM, h:mm a');
    return m.format('DD MMM YYYY, h:mm a');
};


const Overview = ({ leadDetail, activityList, onChangeTab, reloadTaskCounter, LeadNotes, handleMenuItems, setSelectTreatmentData, setOpenContactFromCall, openContactFromCall, autoAction }) => {

    const theme = useTheme();

    const inputRef = useRef();
    const personalDetailPopupRef = useRef();
    const updateReminderRef = useRef();

    const navigate = useNavigate();

    const { nearestPastData: nearestPastDataV2, nearestData: nearestDataV2 } = useLeadTableHelper('ConsultantBooked');

    const isLight = theme.palette.mode === 'light';

    const isDesktop = useResponsive('down', 'sm');

    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    // §9 MUST FE — use shared hook (consistent with the other 4 chokepoint files
    // — AddReminderPopup, AllLeadTable/TaskChecklistField, LeadDetailTasks,
    // LeadTaskReminder). canView is true for {view, manage}.
    const { canView: hasTasksV2 } = useFeaturePermission('tasks-v2');

    const { isLoader } = useSelector((state) => state.loaderReducer);
    // Read from the canonical /form-deliveries/ slice (Track A.3 migration).
    // The legacy `consentV2` slice still exports an identical state shape, but
    // the FORM_SUBMITTED_RECENT next-step engine needs the data populated by the
    // canonical thunks the new Lead Detail flow now uses.
    const { leadConsentRequests } = useSelector((state) => state.formDeliveries);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const followLead = useSelector(selectFollowLead);
    const [anchorRef, setAnchorRef] = useState(null);
    const [active, setActive] = useState(0);
    const [reminderId, setReminderID] = useState(0);
    const [reminderData, setReminderData] = useState('');
    const [openSidebar, setOpenSidebar] = useState(false);
    const [validStep, setValidStep] = useState(false);
    const [open, setOpen] = useState(false);
    const [treatmentCon, setTreatmentCon] = useState(false);
    const [cancelTreatment, setCancelTreatment] = useState(false);
    const [markComplete, setMarkComplete] = useState(false);
    const { pathname } = useLocation();
    const location = useLocation();
    const routeData = new URLSearchParams(location.search);
    const searchPractice = routeData.get('practiceId');
    const taskId = routeData.get('taskId');
    const tab = routeData.get('tab');
    const metaData = leadDetail && leadDetail?.lead_metadata;
    const leadSourceMetaData = leadDetail && leadDetail?.lead_source && leadDetail?.lead_source?.metadata;
    const [leadAppointment, setLeadAppointment] = useState('');
    const [bookedLeadAppointment, setBookedLeadAppointment] = useState('');
    const [pastAppointment, setPastAppointment] = useState('');
    const [treatmentData, setTreatmentData] = useState('');
    const [assignees, setAssignees] = useState([]);
    const [openContactWhatsapp, setOpenContactWhatsapp] = useState({ open: false });
    const [syncLoading, setSyncLoading] = useState(false);
    const [cancelDentallyLoading, setCancelDentallyLoading] = useState(false);
    const [dentallySlot, setDentallySlot] = useState(null);
    const [selectedDentallyTreatment, setSelectedDentallyTreatment] = useState(null);
    const [dentallyAssignees, setDentallyAssignees] = useState([]);
    const [followUpConfirmStepState, setFollowUpConfirmStepState] = useState({});
    const [useDentallyFlow, setUseDentallyFlow] = useState(true);
    // PMS scheduling state
    const [pmsSlot, setPmsSlot] = useState(null);
    const [pmsPractitioner, setPmsPractitioner] = useState(null);
    const [pmsDate, setPmsDate] = useState(null);
    const [pmsConfirmStepState, setPmsConfirmStepState] = useState({});
    const [leadData, setLeadData] = useState({
        lead_id: '',
        treatment_id: '',
        price: '',
        first_name: '',
        last_name: '',
        status: '',
        treatment_name: '',
        created_at_human: ''
    });
    const [currentTreatmentData, setCurrentTreatmentData] = useState({});
    const [treatmentOpen, setTreatmentOpen] = useState(false);
    const treatmentStatus = leadDetail?.lead_treatments?.[0]?.status;
    const isInvisalignTreatment = () => leadDetail?.lead_treatments?.[0]?.treatment === 'Invisalign';
    const shouldRenderClinCheck = (treatmentStatus === 'CONSULTATION_ATTENDED' || treatmentStatus === 'CONSULTATION_BOOKED') && isInvisalignTreatment();
    const finalTreatmentArray = leadDetail?.lead_treatments?.filter((ele) => ele.status !== 'CLOSED' || leadDetail?.lead_treatments?.length <= 3);
    const {
        isAppointmentBooked,
        attendance,
        followUpLead,
        leadReminder,
        contactLead,
        BookingAttendance,
        markAsComplete,
        upComingData,
        isDentallyBooking,
        taskTableData: {
            limit,
            offset,
            filter,
            assignUser
        },
    } = useSelector((state) => state.lead);
    const { dentallyEnabledGlobal } = useSelector((state) => state.practice);
    const { pmsEnabledGlobal } = useSelector((state) => state.pmsSchedule);
    const {
        referral: referralData,
    } = useSelector((state) => state.schema);
    const { practiceTreatment } = useSelector((state) => state.practiceTreatmentList);
    const anchorTreatmentRef = useRef(null);
    const [anchorElAssign, setAnchorElAssign] = useState(null);
    const [anchorEditTreatment, setAnchorEditTreatment] = useState(null);
    const assigneeData = upComingData?.assignees?.filter((el) => el?.user?.first_name && !el?.user?.is_superuser);
    const [templateOpen, setTemplateOpen] = useState('');
    const [timelineFilter, setTimelineFilter] = useState('All');
    const [width, height] = useWindowSize();

    // V1 attended-checklist helpers removed — surface migrated to AttendedChecklistV2.

    useEffect(() => {
        if (followLead) {
            const treatmentFilter = followLead?.lead_appointment;
            const upcomingAppointment = treatmentFilter?.filter((el) => (
                moment(el.datetime, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') > moment().format('YYYY-MM-DD HH:mm:ss')
            ));
            const upcomingAppointmentSorting = upcomingAppointment?.sort((a, b) => new Date(moment(a.datetime, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD hh:mm:ss')) - new Date(moment(b.datetime, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD hh:mm:ss')));
            const bookedStatusFilter = upcomingAppointmentSorting?.filter((el) => el.status === 'BOOKED');
            const PastAppointment = treatmentFilter?.filter((el) => el.status === 'ATTENDED');
            const PastAppointmentSorting = PastAppointment?.sort((a, b) => new Date(moment(a.datetime, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD hh:mm:ss')) - new Date(moment(b.datetime, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD hh:mm:ss')));
            setLeadAppointment(bookedStatusFilter);
            setBookedLeadAppointment(bookedStatusFilter);
            setPastAppointment(PastAppointmentSorting);
        }
    }, [followLead]);

    const getBtnName = (treatment) => {
        if ((treatment?.lead_contacted_counts?.find(item => item.status === treatment?.status)?.count === 0 || treatment?.lead_contacted_counts?.length === 0) && treatment.status === 'NEW') {
            return leadDetail?.lead_contact?.preferred_contact_method?.toLowerCase() === "whatsapp" ? 'Contact Lead (WhatsApp)' : 'Contact Lead';
        }
        if (statuses.includes(leadDetail?.lead_treatments?.length > 0 && treatment.status)) {
            return 'Follow up';
        }
        switch (treatment.status) {
            case 'CONSULTATION_BOOKED':
                return 'Record Attendance';
            case 'TREATMENT_STARTED':
                return 'Complete Treatment';
            case 'CLOSED':
                return 'Completed';
            default:
                return '';
        }
    };

    const getHtmlElement = () => document.querySelector('body');

    const removeClass = () => {
        const htmlElement = getHtmlElement();
        htmlElement.classList.remove('overflow-hidden');
    };

    const getStatus = (treatment) => TAB_HEAD.map((e1) => {
        let latestData = '';
        if (treatment?.status === e1.value) {
            latestData = e1.label;
        }
        return latestData;
    });

    useEffect(() => {
        dispatch(getAppointment(practiceId, leadDetail?.id));
        dispatch(updateSelectedSimilarLeads({ leadIds: [] }));
    }, []);

    useEffect(() => {
        if (searchPractice && taskId) {
            dispatch(switchPractice(searchPractice));
            // §9 MUST FE — V2 practices skip the V1 reminder fetch; the V2 task
            // slideout is reached via /tasks-v2/<id> (handled elsewhere). V1
            // practices keep the existing /reminders/ flow.
            if (!hasTasksV2) {
                dispatch(getReminderData(searchPractice, taskId));
                setOpenSidebar(true);
            }
        }
    }, [searchPractice, taskId, hasTasksV2]);

    useEffect(() => {
        if (leadDetail?.lead_treatments?.length > 0) {
            setTreatmentData(leadDetail?.lead_treatments[0]);
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, 'leadNotes', leadDetail?.id, '', '', '', 'counter'));
        }
    }, [leadDetail, practiceId]);

    useEffect(() => {
        if (upComingData) {
            setReminderData(upComingData);
        }
    }, [upComingData]);

    const {
        toggle: openFollowLead,
        onOpen: onOpenFollowLead,
        onClose: onCloseFollowLead
    } = useToggle();

    const {
        toggle: leadDetailModal,
        onOpen: onLeadDetail,
        onClose: onCloseLeadDetail
    } = useToggle();

    const {
        toggle: openConsultationAttend,
        onOpen: onOpenConsultationAttend,
        onClose: onCloseConsultationAttend
    } = useConsultationAttendToggle();

    const {
        toggle: openRecordAttend,
        onOpen: onOpenRecordAttend,
        onClose: onCloseRecordAttend
    } = useRecordAttendToggle();

    const {
        toggle: openUnRecordAttend,
        onOpen: onOpenUnRecordAttend,
        onClose: onCloseUnRecordAttend
    } = useUnRecordAttendToggle();

    const {
        toggle: openArchiveLead,
        onOpen: onOpenArchiveLead,
        onClose: onCloseArchiveLead
    } = useArchivedToggle();

    const {
        toggle: openAppointmentAssignTask,
        onOpen: onOpenAppointmentAssignTask,
        onClose: onCloseAppointmentAssignTask
    } = useAssignTaskToggle();

    const CreateLeadHeaderData = {
        title: 'Create Lead',
        button1: 'Save & Continue Later',
        button2: 'Close',
    };

    const editDetailHandler = () => onLeadDetail();

    const closeEditDetails = () => onCloseLeadDetail();

    const closeHandler = (value) => {
        setOpenSidebar(false);
        if (value === 'finish') {
            setTreatmentCon(false);
            dispatch(setLoader(false));
            setCancelTreatment(false);
            dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', limit, offset, filter, leadDetail?.id, assignUser));
            reloadTaskCounter({ userId: assignUser, id: leadDetail?.id });
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
        }
    };

    const onSubmit = (data) => {
        setValidStep(!!data);
    };

    useEffect(() => {
        if (markAsComplete) {
            switch (followUpLead) {
                case 'contactLead':
                    dispatch(updateLeadDetail(isAppointmentBooked, handleClose));
                    break;
                case 'consultationAttended':
                    dispatch(ConsultationAttended(handleClose));
                    break;
                case 'recordAttended':
                    dispatch(RecordAttended(handleClose));
                    break;
                case 'recordUnAttended':
                    dispatch(recordUnAttended(handleClose));
                    break;
                default:
                    break;
            }
        }
    }, [markAsComplete, followUpLead]);

    const openAppointmentAssignTaskFuc = (value, assignees, event) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget);
        onOpenAppointmentAssignTask();
        setReminderID(value?.lead_id);
        setAssignees(assignees);
    };

    const onCloseAppointmentAssignTaskPopup = () => onCloseAppointmentAssignTask();

    const handleClose = (status, Archived) => {
        dispatch(setLoader(false));
        if (status === 'markComplete') {
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', limit, offset, filter, leadDetail?.id, assignUser, '', 'leadNotes', 'counter'));
            reloadTaskCounter({ userID: assignUser, id: leadDetail?.id });
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
            setOpenSidebar(false);
        };
        if (status?.toLowerCase?.() === 'finish' && Archived === true) {
            navigate('/dashboard/app');
            setOpenSidebar(false);
            dispatch(clearLead());
            dispatch(setCurrentTreatmentDataGlobal(null));
            dispatch(updateSteps(null));
            dispatch(updateFollowUpLead(null));
            setAnchorElAssign(null);
            removeClass();
            return;
        };
        if (status?.toLowerCase?.() === 'finish' && updateReminderRef.current) {
            // §9 MUST FE — V2 practices complete through V2 endpoint; V1
            // practices keep the legacy /reminders/ PATCH path.
            if (hasTasksV2) {
                if (upComingData?.id) {
                    dispatch(completeTask(practiceId, upComingData.id, handleReminder));
                }
            } else {
                const data = {
                    datetime: `${moment().format('DD-MM-YYYY HH:mm:ss')}.0Z`,
                    is_completed: true
                };
                dispatch(updateReminder(data, upComingData?.id, practiceId, handleReminder));
            }
            setOpenSidebar(false);
        } else if (status?.toLowerCase?.() === 'finish') {
            handleReminder();
            setOpenSidebar(false);
        };
        dispatch(startLoadingData(false));
        setAnchorRef(null);
        setAnchorElAssign(null);
        setOpen(false);
        setDentallySlot(null);
        setSelectedDentallyTreatment(null);
        setDentallyAssignees([]);
        setPmsSlot(null);
        setPmsPractitioner(null);
        setPmsDate(null);
        setUseDentallyFlow(true);
        setFollowUpConfirmStepState({});
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateSteps(null));
        dispatch(updateFollowUpLead(null));
        onCloseFollowLead();
        onCloseConsultationAttend();
        onCloseRecordAttend();
        onCloseUnRecordAttend();
        onCloseArchiveLead();
        removeClass();
    };

    const STEPS = [
        {
            label: 'Contact',
            component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} followLeadForScript={followLead} />
        }
    ];

    const [leadStep, setLeadStep] = useState(STEPS);

    useEffect(() => {
        if (contactLead) {
            const STEPS = [
                {
                    label: 'Contact',
                    component: <FollowUp ref={inputRef} handleNext={onSubmit} handleClose={handleClose} />
                }
            ];
            setLeadStep(STEPS);
        } else {
            const STEPS = [
                {
                    label: 'Contact',
                    component: <Activities activityList={activityList} notAllow />
                }
            ];
            setLeadStep(STEPS);
        }
    }, [contactLead]);

    useEffect(() => {
        if (BookingAttendance) {
            const steps = [...STEPS];
            if (isAppointmentBooked === 'Booking Details' && pmsEnabledGlobal && !dentallyEnabledGlobal) {
                // PMS path: 2 steps — Availability → Confirm Booking
                steps.push({
                    label: 'Select Appointment',
                    component: (
                        <PmsAvailabilityWizardStep
                            ref={inputRef}
                            handleNext={onSubmit}
                            practiceId={practiceId}
                            pmsSlot={pmsSlot}
                            onSlotSelected={setPmsSlot}
                            selectedPractitioner={pmsPractitioner}
                            onPractitionerSelected={setPmsPractitioner}
                            selectedDate={pmsDate}
                            onDateSelected={setPmsDate}
                        />
                    ),
                });
                steps.push({
                    label: 'Confirm Booking',
                    ...pmsConfirmStepState,
                    component: (
                        <PmsBookingConfirmStep
                            ref={inputRef}
                            pmsSlot={pmsSlot}
                            practiceId={practiceId}
                            existingLead={leadDetail ? {
                                id: leadDetail.id,
                                first_name: leadDetail.first_name,
                                last_name: leadDetail.last_name,
                                lead_contact: {
                                    phone: leadDetail.lead_contact?.phone,
                                    email: leadDetail.lead_contact?.email,
                                },
                            } : null}
                            existingTreatmentId={currentTreatmentData?.treatmentData?.id ? Number(currentTreatmentData.treatmentData.id) : null}
                            onClose={(success) => {
                                if (success) {
                                    dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
                                    handleClose('finish');
                                }
                            }}
                            onStepStateChange={setPmsConfirmStepState}
                        />
                    ),
                });
            } else if (isAppointmentBooked === 'Booking Details' && dentallyEnabledGlobal && useDentallyFlow) {
                // Dentally path: 2 steps — Treatment & Availability → Confirm Booking
                steps.push({
                    label: 'Treatment & Availability',
                    component: (
                        <Box>
                            <BookingModeToggle useDentally onChange={handleToggleBookingMode} />
                            <DentallyTreatmentAvailabilityWizardStep
                                ref={inputRef}
                                handleNext={onSubmit}
                                practiceId={practiceId}
                                dentallySlot={dentallySlot}
                                onSlotSelected={setDentallySlot}
                                selectedDentallyTreatment={selectedDentallyTreatment}
                                onTreatmentSelected={setSelectedDentallyTreatment}
                                assignees={dentallyAssignees}
                                onAssigneesChanged={setDentallyAssignees}
                            />
                        </Box>
                    ),
                });
                steps.push({
                    label: 'Confirm Booking',
                    ...followUpConfirmStepState,
                    component: (
                        <DentallyFollowUpConfirmWizardStep
                            ref={inputRef}
                            selectedSlot={dentallySlot}
                            practiceId={practiceId}
                            existingLead={leadDetail ? {
                                id: leadDetail.id,
                                first_name: leadDetail.first_name,
                                last_name: leadDetail.last_name,
                                lead_contact: {
                                    phone: leadDetail.lead_contact?.phone,
                                    email: leadDetail.lead_contact?.email,
                                },
                                dob: leadDetail.dob,
                                salutation: leadDetail.salutation,
                                sex: leadDetail.sex,
                                nhs_number: leadDetail.nhs_number,
                                emergency_contact_name: leadDetail.emergency_contact_name,
                                emergency_contact_phone: leadDetail.emergency_contact_phone,
                            } : null}
                            existingTreatmentId={currentTreatmentData?.treatmentData?.id ? Number(currentTreatmentData.treatmentData.id) : null}
                            onClose={(success) => {
                                if (success) {
                                    // Refresh lead data so the pending booking banner appears immediately
                                    dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
                                    handleClose('finish');
                                }
                            }}
                            onStepStateChange={setFollowUpConfirmStepState}
                        />
                    ),
                });
            } else {
                steps.push({
                    label: isAppointmentBooked,
                    component: isAppointmentBooked === 'Booking Details'
                        ? <Box>
                            {dentallyEnabledGlobal && <BookingModeToggle useDentally={false} onChange={handleToggleBookingMode} />}
                            <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview />
                        </Box>
                        : isAppointmentBooked === 'Unable to contact' ?
                            <UnableToContact ref={inputRef} handleNext={onSubmit} isOverview completeFlow={handleClose} />
                            : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                });
            }
            setLeadStep(steps);
            return;
        }
        setLeadStep(STEPS);
    }, [BookingAttendance, dentallySlot, selectedDentallyTreatment, dentallyAssignees, followLead, followUpConfirmStepState, useDentallyFlow, pmsSlot, pmsPractitioner, pmsDate, pmsConfirmStepState]);

    useEffect(() => {
        if (attendance && isAppointmentBooked !== 'Appointment Not Booked') {
            const steps = [...STEPS];
            if (attendance === 'attendance') {
                steps.push({
                    label: isAppointmentBooked,
                    component: isAppointmentBooked === 'Booking Details'
                        ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview />
                        : isAppointmentBooked === 'Unable to contact' ?
                            <UnableToContact ref={inputRef} handleNext={onSubmit} isOverview completeFlow={handleClose} />
                            : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({
                    label: 'Appointment Outcome',
                    component: <AttendedAppointment ref={inputRef} handleNext={onSubmit} isOverview />
                });
            } else {
                steps.push({
                    label: isAppointmentBooked,
                    component: isAppointmentBooked === 'Booking Details'
                        ? <TreatmentAndAppointment ref={inputRef} type={'followUp'} handleNext={onSubmit} isOverview />
                        : isAppointmentBooked === 'Unable to contact' ?
                            <UnableToContact ref={inputRef} handleNext={onSubmit} isOverview completeFlow={handleClose} />
                            : <AppointmentPage ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({
                    label: 'Personal Details',
                    component: <PersonalDetails ref={inputRef} handleNext={onSubmit} />
                });
                steps.push({
                    label: 'Payment options',
                    component: <PaymentOption ref={inputRef} handleNext={onSubmit} />
                });
                if (dentallyEnabledGlobal && isDentallyBooking) {
                    steps.push({
                        label: 'Dentally Confirmation',
                        component: <DentallyPaymentConfirmation ref={inputRef} handleNext={onSubmit} />
                    });
                }
                steps.push({
                    label: 'Message review & reminders',
                    component: <MessageAndReminder ref={inputRef} handleNext={onSubmit} type={'CreatLead'} />
                });
            }
            setLeadStep(steps);
        } else {
            setLeadStep(STEPS);
        }
    }, [attendance, isDentallyBooking]);

    useEffect(() => {
        if (!followUpLead) {
            handleClose();
            dispatch(updateSteps(null));
        }
    }, [followUpLead]);

    // Auto-trigger workflow action from command palette or navigation state
    const autoActionProcessedRef = useRef(false);
    useEffect(() => {
        if (!autoAction || !leadDetail?.id || !leadDetail?.lead_treatments?.length || autoActionProcessedRef.current) return;
        autoActionProcessedRef.current = true;

        const treatment = leadDetail.lead_treatments[0];
        // Small delay to ensure component is fully mounted and dialogs are ready
        const timer = setTimeout(() => {
            switch (autoAction) {
                case 'bookConsultation':
                    btnHandler(null, '', treatment);
                    break;
                case 'markAttended':
                    handleSetTreatmentDataGlobal({ leadDetail, treatment, setCurrentTreatmentData });
                    getLeadData();
                    dispatch(updateFollowUpLead('recordAttended'));
                    onOpenRecordAttend();
                    break;
                case 'markFTA':
                    handleSetTreatmentDataGlobal({ leadDetail, treatment, setCurrentTreatmentData });
                    getLeadData();
                    dispatch(updateFollowUpLead('recordUnAttended'));
                    onOpenUnRecordAttend();
                    break;
                case 'startTreatment':
                    setTreatmentCon(true);
                    break;
                case 'completeTreatment':
                    setTreatmentCon(true);
                    break;
                default:
                    break;
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [autoAction, leadDetail]);

    const getLeadData = () => {
        dispatch(followUpSlice(leadDetail?.id, practiceId));
        setTimeout(() => {
            dispatch(getAppointment(practiceId, leadDetail?.id));
        }, 800);
    };

    const btnHandler = (event, value, treatment, isCallScript) => {
        if (leadDetail?.lead_contact?.preferred_contact_method?.toLowerCase() === "whatsapp") {
            dispatch(initializeFacebookAuthToken());
            setOpenContactWhatsapp({ open: true, treatmentCallBack: () => { } });
        }
        localStorageRemoveItem('localTreatmentData');
        if (event === 'called') {
            updateReminderRef.current = true;
        }
        tableData();
        dispatch(fetchMergeTagValueForLeads(leadDetail?.id));
        dispatch(fetchMergeTagValueForTreatments(leadDetail?.id, getTreatmentDetails('id', treatment, leadDetail) || null));
        setLeadData({
            lead_id: leadDetail?.id || '',
            treatment_id: getTreatmentDetails('id', treatment, leadDetail),
            price: getTreatmentDetails('price', treatment, leadDetail),
            first_name: leadDetail.first_name || '',
            last_name: leadDetail.last_name || '',
            status: getTreatmentDetails('status', treatment, leadDetail),
            treatment_name: getTreatmentDetails('treatment', treatment, leadDetail),
            lead_treatments__lead_contacted_counts__count: getTreatmentDetails('count', treatment, leadDetail) === 0 && isCallScript ? null : getTreatmentDetails('count', treatment, leadDetail),
            clinCheckData: getTreatmentDetails('clinCheck', treatment, leadDetail),
            treatmentData: leadDetail?.lead_treatments
        });
        let STATUS = getTreatmentDetails('status', treatment, leadDetail);
        if (treatment) {
            const payload = {
                lead_id: leadDetail?.id || '',
                first_name: leadDetail.first_name || '',
                last_name: leadDetail.last_name || '',
                treatmentData: treatment
            };
            setCurrentTreatmentData(payload);
            dispatch(setCurrentTreatmentDataGlobal(payload));
        } else {
            setCurrentTreatmentData({});
            dispatch(setCurrentTreatmentDataGlobal(null));
        }
        if (value === 'Archive') {
            dispatch(updateFollowUpLead('archivedLead'));
            onOpenArchiveLead(leadDetail?.id);
            return;
        }
        if (isCallScript) {
            STATUS = 'NEW'; // Setting to new as default beaviour of outbound for call script
        }
        switch (STATUS) {
            case 'NEW': {
                dispatch(updateFollowUpLead('contactLead'));
                dispatch(followUpSlice(leadDetail?.id, practiceId));
                const htmlElement = getHtmlElement();
                htmlElement.classList.add('overflow-hidden');
                onOpenFollowLead();
                return;
            }
            case 'CONSULTATION_ATTENDED':
            case 'ATTENDED':
                dispatch(updateFollowUpLead('consultationAttended'));
                getLeadData();
                onOpenConsultationAttend();
                return;
            case 'CONSULTATION_BOOKED':
            case 'BOOKED':
                setAnchorRef(event.currentTarget);
                if (value === 'called') {
                    updateReminderRef.current = true;
                }
                setOpen(true);
                return;
            case 'FAILED_TO_ATTEND_CONSULTATION':
            case 'FAILED_TO_ATTEND':
                getLeadData();
                handleAttenedFailedClick();
                return;
            case 'TREATMENT_STARTED':
                setTreatmentCon(true);
                break;
            default:
                break;
        }
    };

    const handleReminder = () => {
        dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
        dispatch(getLeadNotes(leadDetail?.id, practiceId, handleSuccess));
        dispatch(getLeadNotesWithFilter(leadDetail?.id, practiceId, handleSuccess));
        dispatch(getActivities(practiceId, leadDetail.id, 10, 0));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', limit, offset, filter, leadDetail?.id, assignUser, '', '', 'counter'));
        reloadTaskCounter({ id: leadDetail?.id });
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
    };

    const getCurrentTreatmentData = () => {
        if (!isEmpty(currentTreatmentData?.treatmentData)) {
            return currentTreatmentData?.treatmentData;
        }
        return leadDetail?.lead_treatments?.[0];
    };

    const apiHandler = () => {
        if (treatmentCon) {
            const data = {
                treatment: getCurrentTreatmentData()?.treatment || '',
                custom_price: getCurrentTreatmentData()?.price || ''
            };
            dispatch(setLoader(true));
            dispatch(CompleteTreatment(data, getCurrentTreatmentData()?.lead, getCurrentTreatmentData()?.id, practiceId, closeHandler));
        }
        if (cancelTreatment && leadDetail?.lead_treatments?.length > 0) {
            dispatch(deleteTreatment(practiceId, leadDetail.id, getCurrentTreatmentData()?.id, handleSuccess));
        }
    };

    const handleSuccess = (data) => {
        if (data?.cancelTreatment) {
            enqueueSnackbar(data.message || '', {
                variant: data.success ? 'success' : 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
            closeHandler();
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, '', leadDetail?.id, ''));
            reloadTaskCounter({ id: leadDetail?.id });
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
            dispatch(getActivities(practiceId, leadDetail?.id, 10, 0));
            setCancelTreatment(false);
        }
        if (data.message === 'Task completed !') {
            setMarkComplete(false);
            const key = enqueueSnackbar(data.message || '', {
                variant: data.success ? 'success' : 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                autoHideDuration: 5000,
                action:
                    <>
                        <Button onClick={() => undoReminder()} variant='success' size='small' sx={{ color: common.mintyZest, '&:hover': { bgcolor: 'rgba(84, 214, 44, 0.16)' } }}>
                            Undo
                        </Button>
                        <Iconify onClick={() => closeSnackbar(key)} icon={'radix-icons:cross-2'} height={15} width={15} sx={{ margin: '0px 8px', cursor: 'pointer' }} />
                    </>
            });
        }
    };

    const undoReminder = () => {
        setMarkComplete(false);
        // §9 MUST FE — V2 reopen via /tasks/<id>/reopen/; V1 keeps PATCH /reminders/.
        if (hasTasksV2) {
            if (upComingData?.id) {
                dispatch(reopenTask(practiceId, upComingData.id, handleClose));
            }
        } else {
            const data = { is_completed: false };
            dispatch(updateReminder(data, upComingData?.id, practiceId, handleClose, 'markComplete'));
        }
        closeSnackbar();
    };

    const buttonHandleClose = (event) => {
        if (anchorRef?.current && anchorRef?.current?.contains(event?.target)) {
            return;
        }
        setOpen(false);
    };

    const tableData = () => {
        dispatch(tableLead({
            lead_id: leadDetail?.id || '',
            treatment_id: leadDetail?.lead_treatments?.[0]?.id || '',
            price: leadDetail?.lead_treatments?.[0]?.price || '',
            first_name: leadDetail.first_name || '',
            last_name: leadDetail.last_name || '',
            status: leadDetail?.lead_treatments?.[0]?.status || '',
            treatment_name: leadDetail?.lead_treatments?.[0]?.treatment || '',
            lead_treatments__lead_contacted_counts__count: leadDetail?.lead_treatments?.[0]?.lead_contacted_counts?.find(item => item.status === leadDetail?.lead_treatments?.[0]?.status)?.count || 0,
            treatmentData: leadDetail?.lead_treatments
        }));
    };

    const handleAttenedFailedClick = (id, reminder) => {
        if (reminder) {
            setLeadData({ ...setRowLeadData(reminder, leadData), lead_id: reminder?.lead_treatment?.lead || id || '' });
        }
        handleSetTreatmentDataGlobal({ leadDetail, treatment: reminder, setCurrentTreatmentData });
        getLeadData();
        dispatch(updateFollowUpLead('recordUnAttended'));
        onOpenUnRecordAttend();
    };

    const handleAttenedClick = (data, treatment) => {
        setLeadData({
            lead_id: leadDetail?.id || '',
            treatment_id: treatment?.lead_treatment?.id,
            price: treatment?.lead_treatment?.price,
            first_name: treatment?.lead?.first_name || '',
            last_name: treatment?.lead?.last_name || '',
            status: treatment?.lead_treatment?.status,
            treatment_name: treatment?.lead_treatment?.treatment,
            lead_treatments__lead_contacted_counts__count: treatment?.lead_treatment?.lead_contacted_counts?.find(item => item.status === treatment?.lead_treatment?.status)?.count || 0,
            clinCheckData: treatment?.lead_treatment?.leadtreatment_clincheck,
            treatmentData: leadDetail?.lead_treatments
        });
        handleSetTreatmentDataGlobal({ leadDetail, treatment, setCurrentTreatmentData });
        getLeadData();
        dispatch(updateFollowUpLead('recordAttended'));
        onOpenRecordAttend();
    };

    const popupClose = (status) => {
        setTreatmentCon(false);
        setCancelTreatment(false);
        onCloseAssignTask();
        setAnchorElAssign(null);
        if (status) {
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
            dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, 'leadNotes', leadDetail?.id, ''));
        }
    };

    const {
        toggle: openAssignTask,
        onOpen: onOpenAssignTask,
        onClose: onCloseAssignTask
    } = useAssignTaskToggle();

    const OpenAssignTask = (value, event) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget);
        setReminderID(value);
        onOpenAssignTask();
    };

    const markCompleteBtn = (value) => {
        setMarkComplete(value);
        // §9 MUST FE — V2 practices complete via /tasks/<id>/complete/.
        if (hasTasksV2) {
            dispatch(completeTask(practiceId, value, (res) => {
                handleClose(res);
                if (handleSuccess) handleSuccess(res);
            }));
        } else {
            const data = { is_completed: true };
            dispatch(updateReminder(data, value, practiceId, handleClose, 'markComplete', handleSuccess));
        }
    };

    const getReminderBtn = (status, leadTreatment, archive) => {
        if (archive) {
            return <Button
                variant='contained'
                disabled
                sx={archivedButton}
            >
                Archived
            </Button>;
        }
        if (!leadTreatment || status === 'CLOSED') {
            return '';
        }
        const isLeadDataReady = Boolean(followLead?.lead_treatments?.length);
        switch (status) {
            case 'TREATMENT_STARTED':
                return <Button
                    variant='contained'
                    color='primary'
                    disabled={!isLeadDataReady}
                    onClick={() => btnHandler('called', '', leadTreatment)}
                    sx={taskButton}
                >
                    Complete treatment
                </Button>;
            default:
                return <Button
                    variant='contained'
                    color='primary'
                    startIcon={<Iconify icon={'fluent:call-32-filled'} height={15} width={15} />}
                    disabled={!isLeadDataReady}
                    onClick={() => btnHandler('called', '', leadTreatment)}
                    sx={taskButton}
                >
                    Follow Up
                </Button>;
        }
    };

    const sidebarHandler = (data) => {
        setReminderData(data);
        setOpenSidebar(true);
        const tabQuery = tab?.length > 0 ? `&tab=${tab}` : '';
        navigate(`?practiceId=${practiceId}&taskId=${data.id}${tabQuery}`);
    };

    const sidebarCloser = () => {
        setOpenSidebar(false);
        const tabQuery = tab?.length > 0 ? `?tab=${tab}` : '';
        navigate(`${pathname}${tabQuery}`, { replace: true });
        setReminderData('');
    };

    const handleArchivedClose = () => {
        onCloseArchiveLead();
        if (openFollowLead) {
            dispatch(updateFollowUpLead('contactLead'));
        }
    };

    const {
        toggle: EditTreatment,
        onOpen: onEditTreatment,
        onClose: onCloseEditTreatment
    } = useAddTreatment();

    const handleAddTreatment = (event) => {
        onEditTreatment();
        setAnchorEditTreatment(event.currentTarget);
    };

    const handleTogglePopper = (id, ele) => {
        anchorTreatmentRef.current = document.getElementById(`button-${ele.id}`);
        setTreatmentOpen((prevStates) => ({
            ...prevStates,
            [id]: !prevStates[id],
        }));
    };

    const isPopperOpen = (id) => Boolean(treatmentOpen[id]);

    const handleClickEditTreatment = (ele) => { onChangeTab('', 'Treatments'); setSelectTreatmentData(ele); };

    // ─── Next Step Suggestion Engine ───
    const getNextStepSuggestion = () => {
        const primaryTreatment = finalTreatmentArray?.[0];
        if (!primaryTreatment) return null;
        // Dentally payment pending — suppress standard contact step
        if (dentallyEnabledGlobal && primaryTreatment.is_treatment_fee_pending) return null;
        const { status } = primaryTreatment;
        const contactCount = primaryTreatment?.lead_contacted_counts?.find(
            (item) => item.status === status
        )?.count || 0;
        const lastActivity = activityList?.[0];
        const daysSinceActivity = lastActivity
            ? Math.max(0, Math.round((Date.now() - new Date(moment(lastActivity.timestamp, 'DD/MM/YYYY HH:mm:ss').toISOString())) / 86400000))
            : 999;

        // ── Highest priority: a form was submitted in the last 24h. Patient acted; the
        //    rep should review their submission rather than be told to chase them. This
        //    replaces the previous standalone "Recent Consent Submission" banner so the
        //    Next-step engine remains the single source of truth for the headline CTA.
        const consentRequests = leadConsentRequests?.results || [];
        const parseConsentDate = (ds) => {
            if (!ds) return null;
            const m = moment(ds, 'DD-MM-YYYY HH:mm:ss');
            return m.isValid() ? m : moment(ds);
        };
        const recentSubmission = consentRequests.find((r) => {
            if (r.status !== 'SUBMITTED' || !r.submitted_at) return false;
            const parsed = parseConsentDate(r.submitted_at);
            if (!parsed || !parsed.isValid()) return false;
            const hoursSince = (Date.now() - parsed.valueOf()) / 3600000;
            return hoursSince >= 0 && hoursSince <= 24;
        });
        if (recentSubmission) {
            const formName = recentSubmission.form_name || recentSubmission.form?.name || 'Form';
            const submittedMoment = parseConsentDate(recentSubmission.submitted_at);
            const timeAgo = submittedMoment ? submittedMoment.fromNow() : '';
            return {
                ...NEXT_STEP_SUGGESTIONS.FORM_SUBMITTED_RECENT,
                message: NEXT_STEP_SUGGESTIONS.FORM_SUBMITTED_RECENT.getMessage(formName, timeAgo),
                treatment: primaryTreatment,
                submission: recentSubmission,
            };
        }

        if (status === 'NEW' && (contactCount === 0 || daysSinceActivity > 2)) {
            return { ...NEXT_STEP_SUGGESTIONS.NEW_NO_CONTACT, message: NEXT_STEP_SUGGESTIONS.NEW_NO_CONTACT.getMessage(daysSinceActivity), treatment: primaryTreatment };
        }
        if (status === 'CONSULTATION_BOOKED') {
            const upcomingAppt = leadAppointment?.[0];
            if (upcomingAppt) {
                const daysUntil = Math.max(0, Math.round((new Date(moment(upcomingAppt.datetime, 'DD-MM-YYYY HH:mm:ss').toISOString()) - Date.now()) / 86400000));
                return { ...NEXT_STEP_SUGGESTIONS.CONSULTATION_BOOKED_UPCOMING, message: NEXT_STEP_SUGGESTIONS.CONSULTATION_BOOKED_UPCOMING.getMessage(daysUntil), treatment: primaryTreatment };
            }
        }
        if (status === 'CONSULTATION_ATTENDED') {
            return { ...NEXT_STEP_SUGGESTIONS.CONSULTATION_ATTENDED, message: NEXT_STEP_SUGGESTIONS.CONSULTATION_ATTENDED.getMessage(), treatment: primaryTreatment };
        }
        if (status === 'TREATMENT_STARTED') {
            return { ...NEXT_STEP_SUGGESTIONS.TREATMENT_STARTED, message: NEXT_STEP_SUGGESTIONS.TREATMENT_STARTED.getMessage(), treatment: primaryTreatment };
        }
        if (status === 'FAILED_TO_ATTEND_CONSULTATION') {
            return { ...NEXT_STEP_SUGGESTIONS.FAILED_TO_ATTEND, message: NEXT_STEP_SUGGESTIONS.FAILED_TO_ATTEND.getMessage(daysSinceActivity), treatment: primaryTreatment };
        }
        return null;
    };

    const handleNextStepAction = (suggestion) => {
        if (!suggestion) return;
        if (suggestion.action === 'contact' || suggestion.action === 'followup') {
            btnHandler('', '', suggestion.treatment);
        } else if (suggestion.action === 'communicate') {
            onChangeTab('', 'All communications');
        } else if (suggestion.action === 'forms') {
            // Route to the Forms tab — the user can drill into the recent submission there.
            onChangeTab('', 'Forms');
        }
    };

    const handleToggleBookingMode = (useDentally) => {
        setUseDentallyFlow(useDentally);
        if (!useDentally) {
            setDentallySlot(null);
            setSelectedDentallyTreatment(null);
            setDentallyAssignees([]);
        }
    };

    // Dentally sync — retry pending appointment sync
    const handleSyncDentally = async () => {
        setSyncLoading(true);
        try {
            const success = await syncDentallyAppointment({
                practiceId,
                leadId: leadDetail?.id,
                appointments: followLead?.lead_appointment || [],
                leadMetadata: leadDetail?.lead_metadata || [],
                enqueueSnackbar,
            });
            if (success) {
                dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
            }
        } finally {
            setSyncLoading(false);
        }
    };

    // Dentally cancel — delete a Dentally appointment after CRM cancellation
    const handleCancelDentally = async () => {
        setCancelDentallyLoading(true);
        try {
            const metadata = leadDetail?.lead_metadata || [];
            const dentallyApptId = metadata.find(m => m.key === 'dentally_appointment_id')?.value;

            if (!dentallyApptId) {
                enqueueSnackbar('No Dentally appointment ID found', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
                return;
            }

            const res = await deleteDentallyAppointment(practiceId, dentallyApptId);

            if (res?.ok || res?.status === 200 || res?.status === 204) {
                dispatch(patchLeadMetadata(practiceId, leadDetail?.id, [
                    { key: 'pending_dentally_cancel', value: 'complete' },
                    { key: 'dentally_appointment_id', value: '' },
                ]));
                enqueueSnackbar('Dentally appointment cancelled successfully', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
                dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'));
            } else {
                const errorMsg = typeof res?.data === 'string'
                    ? res.data
                    : res?.data?.detail || res?.data?.message || 'Failed to cancel Dentally appointment';
                enqueueSnackbar(errorMsg, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            }
        } finally {
            setCancelDentallyLoading(false);
        }
    };

    // ─── Timeline Helpers ───
    const getActivityCategory = (activity) => {
        const verb = activity?.verb?.toLowerCase() || '';
        if (verb.includes('note') || verb.includes('comment')) return 'Notes';
        if (verb.includes('email') || verb.includes('whatsapp') || verb.includes('sms') || verb.includes('call')) return 'Communication';
        return 'System';
    };

    const filteredActivities = activityList?.filter((activity) => {
        if (timelineFilter === 'All') return true;
        return getActivityCategory(activity) === timelineFilter;
    });

    // ─── Render Treatment Card (redesigned) ───
    const renderTreatmentCard = (ele, index, length) => {
        const appointment = nearestDataV2(ele?.appointments) || nearestPastDataV2(ele?.appointments);
        const stageIdx = getStageIndex(ele.status);

        return (
            <Box key={index} sx={{
                ...treatmentProgressCard,
                flex: length === 1 ? '1 1 100%' : '1 1 calc(33.33% - 12px)',
                minWidth: length === 1 ? '100%' : 'calc(33.33% - 12px)',
                maxWidth: length === 1 ? '100%' : undefined,
                '@media (max-width: 1559px)': {
                    flex: length === 1 ? '1 1 100%' : '1 1 calc(50% - 12px)',
                    minWidth: length === 1 ? '100%' : 'calc(50% - 12px)',
                },
            }}>
                {/* Header */}
                <Box sx={treatmentCardHeader}>
                    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, flex: 1 }}>
                        <Typography sx={treatmentNameStyle}>{ele?.treatment}</Typography>
                        <Typography sx={treatmentPriceStyle}>{`\u00A3${ele?.price}`}</Typography>
                    </Box>
                    <Box sx={dotsIconBoxStyle} onClick={() => handleTogglePopper(ele.id, ele)} ref={anchorTreatmentRef} id={`button-${ele.id}`}>
                        <Iconify icon={'mdi:dots-horizontal'} sx={{ color: common.grey }} width={24} height={24} />
                    </Box>
                </Box>

                {/* Mini Phase Stepper */}
                <Box sx={miniStepperWrapper}>
                    {JOURNEY_STAGES.map((stage, sIdx) => {
                        const isCompleted = sIdx < stageIdx;
                        const isActive = sIdx === stageIdx;
                        return (
                            <Box key={stage.value} sx={{ display: 'flex', alignItems: 'center', flex: sIdx < JOURNEY_STAGES.length - 1 ? 1 : 'none' }}>
                                <Tooltip title={stage.label} placement='top'>
                                    <Box sx={miniStepDot(isActive, isCompleted, stage.color)} />
                                </Tooltip>
                                {sIdx < JOURNEY_STAGES.length - 1 && (
                                    <Box sx={miniStepConnector(isCompleted, stage.color)} />
                                )}
                            </Box>
                        );
                    })}
                </Box>

                {/* Status pill */}
                <Button sx={statusStyle(ele.status)}>
                    <Iconify
                        icon={ele.status === 'NEW' ? 'mdi:question-mark-circle-outline' : ele.status === 'CONSULTATION_BOOKED' ? 'mdi:calendar-clock' : ele.status === 'FAILED_TO_ATTEND_CONSULTATION' ? 'bx:calendar-x' : ele.status === 'CONSULTATION_ATTENDED' ? 'mdi:calendar-check' : ele.status === 'CLOSED' ? 'material-symbols:check-circle-outline' : ele.status === 'TREATMENT_STARTED' ? 'codicon:debug-start' : 'fluent:cloud-sync-complete-24-filled'}
                        width={24}
                        height={24}
                    />
                    {getStatus(ele)}
                </Button>

                {/* Action button — match the table-cell green outline style so the CTA stands out */}
                <Button
                    variant='outlined'
                    disabled={ele.status === 'CLOSED' || (ele.status === 'CONSULTATION_BOOKED' && appointment?.[0]?.status === 'CANCELLED')}
                    onClick={(e) => btnHandler(e, '', ele)}
                    sx={flwBtnStyle(ele.status === 'CLOSED' || (ele.status === 'CONSULTATION_BOOKED' && appointment?.[0]?.status === 'CANCELLED'))}
                >
                    {getBtnName(ele)}
                </Button>

                {/* Treatment edit Popper (preserved) */}
                <Popper
                    sx={{ zIndex: 1, marginLeft: '10px !important' }}
                    open={isPopperOpen(ele.id)}
                    anchorEl={anchorTreatmentRef.current}
                    role={undefined}
                    placement='bottom-start'
                    transition
                    disablePortal
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                                width: '180px',
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={() => setTreatmentOpen((prevOpen) => !prevOpen)}>
                                    <MenuList
                                        autoFocusItem
                                        id='composition-menu'
                                        aria-labelledby='composition-button'
                                        sx={paperMenuItem}
                                    >
                                        <MenuItem onClick={() => handleClickEditTreatment(ele)} sx={editDetailMenuItem}>
                                            <Iconify icon={'solar:pen-bold'} sx={{ mr: 1 }} />
                                            Edit Treatment
                                        </MenuItem>
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </Box>
        );
    };

    useEffect(() => {
        if (openContactFromCall) {
            btnHandler('', '', finalTreatmentArray[0], true);
        }
    }, [openContactFromCall])

    if (!leadDetail) return null;

    const handleClickAwayLister = (e, popup1Ref) => {
        if (popup1Ref && popup1Ref.current) {
            if (!popup1Ref.current?.contains(e.target)) {
                onCloseEditTreatment();
                dispatch(followUpSlice(leadDetail.id, practiceId, 'LeadDetail'));
                return;
            }
            return;
        }
        onCloseEditTreatment();
        dispatch(followUpSlice(leadDetail.id, practiceId, 'LeadDetail'));
    };

    const handleReloadAPI = (status) => {
        document.body.classList.remove('points-event');
        if (status?.toLowerCase?.() === 'finish') {
            handleClickAwayLister();
            dispatch(clearLead());
            dispatch(setCurrentTreatmentDataGlobal(null));
            if (leadDetail && leadDetail.id) {
                dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, '', leadDetail.id, ''));
                dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
                dispatch(followUpSlice(leadDetail.id, practiceId, 'LeadDetail'));
                dispatch(getActivities(practiceId, leadDetail.id, 10, 0));
            }
        }
    };

    const onClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAssignTask();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const appointmentClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAppointmentAssignTaskPopup();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    const handleCloseEmailCompose = () => {
        setTemplateOpen(false);
        setLeadData({});
        document.body.style.overflowY = 'auto';
    };

    const handleCloseAppointmentAssignee = () => {
        onCloseAppointmentAssignTaskPopup();
        setAnchorElAssign(null);
    };

    return (
        <Stack>
            <SimilarLeadWarningPopup />
            {/* Enquiry Summary Card */}
            <Card sx={overViewCard}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                    <Box sx={{ ...infoIconBox, width: '36px', height: '36px', minWidth: '36px', minHeight: '36px', borderRadius: '10px' }}>
                        <Tooltip title={`Resource referral : ${setLeadSourceIcon(leadDetail?.lead_source?.referral, referralData)?.label || 'not found'}`} placement='bottom' TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                            <Iconify icon={setLeadSourceIcon(leadDetail?.lead_source?.referral, referralData)?.icon} sx={{ color: common.mintBlue }} width={22} height={22} />
                        </Tooltip>
                    </Box>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <Typography sx={{ fontWeight: 700, fontSize: '14px', lineHeight: '20px', mb: 0.25 }}>
                                <span style={{ textTransform: 'capitalize' }}>{leadDetail?.first_name || ''}</span> enquired about {finalTreatmentArray?.length > 0 && finalTreatmentArray[0]?.treatment || ''}
                            </Typography>
                            {(() => {
                                const score = leadDetail?.engagement_score ?? null;
                                if (score === null) return null;
                                const engColor = score >= 76 ? '#10b981' : score >= 51 ? '#3b82f6' : score >= 26 ? '#f59e0b' : '#ef4444';
                                return (
                                    <Tooltip title={`Engagement score: ${score}/100`} placement='top' TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, px: 0.75, py: 0.25, borderRadius: '12px', bgcolor: `${engColor}18`, border: `1px solid ${engColor}40`, mb: 0.25 }}>
                                            <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: engColor, flexShrink: 0 }} />
                                            <Typography variant='caption' sx={{ fontWeight: 700, color: engColor, lineHeight: 1.4 }}>{score}</Typography>
                                        </Box>
                                    </Tooltip>
                                );
                            })()}
                            {(() => {
                                // Click-to-WhatsApp ad attribution — when the lead arrived
                                // via a Meta CTWA ad, the backend captures the referral
                                // block on `LeadSource.metadata.wa_referral`. Show a small
                                // pill so the practice can see at a glance which ad earned
                                // the conversation. Hidden when no referral exists.
                                const waRef = leadDetail?.lead_source?.metadata?.wa_referral;
                                if (!waRef || typeof waRef !== 'object') return null;
                                const headline = waRef.headline || waRef.body || 'WhatsApp ad';
                                const sourceUrl = waRef.source_url || '';
                                const adColor = '#1877f2'; // Meta blue
                                const tooltip = sourceUrl
                                    ? `Came from ad: ${headline}\n${sourceUrl}`
                                    : `Came from ad: ${headline}`;
                                return (
                                    <Tooltip title={tooltip} placement='top' TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, px: 0.75, py: 0.25, borderRadius: '12px', bgcolor: `${adColor}18`, border: `1px solid ${adColor}40`, mb: 0.25, maxWidth: 220 }}>
                                            <Iconify icon='ic:baseline-campaign' sx={{ color: adColor, flexShrink: 0 }} width={14} height={14} />
                                            <Typography variant='caption' sx={{ fontWeight: 700, color: adColor, lineHeight: 1.4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {headline}
                                            </Typography>
                                        </Box>
                                    </Tooltip>
                                );
                            })()}
                        </Box>
                        <Typography variant='body2' sx={{ color: 'grey.500', fontSize: '13px', lineHeight: '18px' }}>
                            {leadDetail?.lead_contact?.note ? <span style={{ display: 'block', fontWeight: 400, mb: '2px' }}>{leadDetail?.lead_contact?.note}</span> : null}
                            <span style={{ fontSize: '12px' }}>{leadDetail?.created_at_human || ''}</span>
                        </Typography>
                    </Box>
                </Box>
                {((metaData && metaData.length !== 0 && metaData.some(el => el.key && el.key.endsWith('?'))) || (leadSourceMetaData && typeof leadSourceMetaData === 'object' && Object.entries(leadSourceMetaData)?.length !== 0 && Object.entries(leadSourceMetaData).some(([key]) => key && key.endsWith('?')))) && <List sx={{ maxWidth: '100%', m: '8px 0 -24px' }}>
                    {metaData && metaData?.map((el, index) => {
                        const { key, value } = el;
                        if (key.endsWith('?')) {
                            return (
                                <ListItem alignItems='flex-start' key={index} sx={{ p: '8px 0' }}>
                                    <ListItemAvatar sx={{ mt: '1px' }}>
                                        <Iconify icon={'charm:info'} color={common.mintBlue} width={24} height={24} />
                                    </ListItemAvatar>
                                    <ListItemText primary={key} secondary={`— ${value}`} sx={textStyle} />
                                </ListItem>
                            );
                        }
                        return null;
                    })}
                    {/* Guard: leadSourceMetaData can be null/undefined during load (REACT-CZ, 4 users) */}
                    {leadSourceMetaData && typeof leadSourceMetaData === 'object' && Object.entries(leadSourceMetaData).map(([key, value], index) => {
                        if (key.endsWith('?')) {
                            return (
                                <ListItem alignItems='flex-start' key={index} sx={{ p: '8px 0' }}>
                                    <ListItemAvatar sx={{ mt: '1px' }}>
                                        <Iconify icon={'charm:info'} color={common.blue} width={24} height={24} />
                                    </ListItemAvatar>
                                    <ListItemText primary={key} secondary={`— ${value}`} sx={textStyle} />
                                </ListItem>
                            );
                        }
                        return null;
                    })}
                </List>}

                {/* Next Step Suggestion — inside enquiry card */}
                {(() => {
                    const suggestion = getNextStepSuggestion();
                    if (!suggestion || finalTreatmentArray?.[0]?.status === 'CLOSED') return null;
                    return (
                        <Box sx={{ ...nextStepCard(suggestion.bgColor), mt: 2 }}>
                            <Box sx={nextStepIcon(suggestion.color)}>
                                <Iconify icon={suggestion.icon} width={24} height={24} />
                            </Box>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography sx={nextStepTitle}>Next step</Typography>
                                <Typography sx={nextStepDescription}>{suggestion.message}</Typography>
                            </Box>
                            <Button
                                variant='contained'
                                sx={{ ...nextStepCTA, bgcolor: suggestion.color, '&:hover': { bgcolor: suggestion.color, opacity: 0.9 } }}
                                onClick={() => handleNextStepAction(suggestion)}
                            >
                                {suggestion.cta}
                            </Button>
                        </Box>
                    );
                })()}


                {/* Recent Consent Submission Banner removed — now handled inside the
                    centralised NEXT_STEP_SUGGESTIONS engine via FORM_SUBMITTED_RECENT,
                    so we don't show two stacked banners for the same event. */}

                {/* Dentally Deferred Booking Pending — payment awaiting */}
                {dentallyEnabledGlobal && (
                    <DentallyPendingBookingBanner
                        practiceId={practiceId}
                        leadDetail={leadDetail}
                        onComplete={() => dispatch(followUpSlice(leadDetail?.id, practiceId, 'LeadDetail'))}
                    />
                )}

                {/* Dentally Payment Pending — no slot pre-selected (payment-first flow) */}
                {dentallyEnabledGlobal && finalTreatmentArray?.[0]?.is_treatment_fee_pending && !leadDetail?.lead_metadata?.find(m => m.key === 'dentally_pending_booking')?.value && (
                    <Box sx={{ ...nextStepCard('rgba(255,171,0,0.08)'), mt: 2 }}>
                        <Box sx={nextStepIcon('#FFAB00')}>
                            <Iconify icon='mdi:cash-clock' width={24} height={24} />
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={nextStepTitle}>Payment Pending — Complete Dentally Booking</Typography>
                            <Typography sx={nextStepDescription}>
                                {finalTreatmentArray[0]?.lead_treatment_payments?.[0]?.amount
                                    ? `Payment of £${finalTreatmentArray[0].lead_treatment_payments[0].amount} sent and awaiting confirmation.`
                                    : 'Payment link sent and awaiting confirmation.'
                                }{' '}Once paid, complete the Dentally booking below.
                            </Typography>
                        </Box>
                        <Button
                            variant='contained'
                            sx={{ ...nextStepCTA, bgcolor: '#FFAB00', '&:hover': { bgcolor: '#FFAB00', opacity: 0.9 }, flexShrink: 0 }}
                            onClick={() => {
                                dispatch(updateBookingSteps('Booking Details'));
                                dispatch(followUpAppointmentHandler('Booking Details'));
                                btnHandler('', '', finalTreatmentArray[0]);
                            }}
                        >
                            Complete Dentally Booking
                        </Button>
                    </Box>
                )}

                {/* Dentally Sync Pending — inside enquiry card */}
                {dentallyEnabledGlobal && leadDetail?.lead_metadata?.find(m => m.key === 'pending_dentally_sync')?.value === 'yes' && (
                    <Box sx={nextStepCard('rgba(7, 141, 238, 0.08)')}>
                        <Box sx={nextStepIcon('#078DEE')}>
                            <Iconify icon='mdi:sync-alert' width={24} height={24} />
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={nextStepTitle}>Dentally Sync Pending</Typography>
                            <Typography sx={nextStepDescription}>
                                Appointment needs to be synced to Dentally
                            </Typography>
                        </Box>
                        <LoadingButton
                            variant='contained'
                            loading={syncLoading}
                            sx={{ ...nextStepCTA, bgcolor: '#078DEE', '&:hover': { bgcolor: '#0666B8' } }}
                            onClick={handleSyncDentally}
                        >
                            Sync Now
                        </LoadingButton>
                    </Box>
                )}

                {/* Dentally Cancel Pending — inside enquiry card */}
                {dentallyEnabledGlobal && leadDetail?.lead_metadata?.find(m => m.key === 'pending_dentally_cancel')?.value === 'yes' && (
                    <Box sx={nextStepCard('rgba(255, 86, 48, 0.08)')}>
                        <Box sx={nextStepIcon('#FF5630')}>
                            <Iconify icon='mdi:calendar-remove' width={24} height={24} />
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={nextStepTitle}>Cancel Dentally Appointment</Typography>
                            <Typography sx={nextStepDescription}>
                                CRM appointment was cancelled — sync cancellation to Dentally
                            </Typography>
                        </Box>
                        <LoadingButton
                            variant='contained'
                            loading={cancelDentallyLoading}
                            sx={{ ...nextStepCTA, bgcolor: '#FF5630', '&:hover': { bgcolor: '#B71D18' } }}
                            onClick={handleCancelDentally}
                        >
                            Cancel Now
                        </LoadingButton>
                    </Box>
                )}

                {/* Treatment Progress Cards — inside enquiry card */}
                <Box sx={{ width: '100%', mt: 2 }}>
                    <Box sx={overViewDynamicOuterBox(finalTreatmentArray)}>
                        {finalTreatmentArray.length > 2 ?
                            <Box sx={finalTreatmentBoxStyle(finalTreatmentArray)}>
                                <Swiper
                                    modules={[Navigation]}
                                    spaceBetween={16}
                                    slidesPerView={2}
                                    navigation={{
                                        nextEl: '.swiper-button-next',
                                        prevEl: '.swiper-button-prev',
                                    }}
                                    pagination={{ clickable: true }}
                                    scrollbar={{ draggable: true }}
                                    breakpoints={{
                                        1560: {
                                            slidesPerView: 3,
                                        },
                                        768: {
                                            slidesPerView: 2,
                                        },
                                        0: {
                                            slidesPerView: 1,
                                        },
                                    }}
                                >
                                    {finalTreatmentArray?.map((ele, index) => <SwiperSlide key={index}>
                                        {renderTreatmentCard(ele, index, finalTreatmentArray?.length)}
                                    </SwiperSlide>)}
                                </Swiper>
                                <div className='swiper-button-next' />
                                <div className='swiper-button-prev' />
                            </Box>
                            :
                            finalTreatmentArray?.map((ele, index) => renderTreatmentCard(ele, index, finalTreatmentArray?.length))
                        }
                        {leadDetail && leadDetail.lead_treatments && leadDetail.lead_treatments?.length === 0 && <Box sx={{ display: 'flex' }}>
                            <Button sx={{ display: 'flex', justifyContent: 'flex-start' }} variant='contained' onClick={(event) => handleAddTreatment(event)}>
                                <Iconify sx={{ mr: '8px' }} icon={'eva:plus-fill'} width={20} height={20} /> Add treatment
                            </Button>
                        </Box>}
                    </Box>
                </Box>
            </Card>
            {hasTasksV2 && leadDetail?.id && (
                <TaskChecklistCard practiceId={practiceId} leadId={leadDetail.id} leadData={leadDetail} />
            )}
            {/* #185 — Recent attachments mini-list. Self-hides when the lead has no media. */}
            {leadDetail?.id && practiceId && (
                <RecentAttachments
                    practiceId={practiceId}
                    leadId={leadDetail.id}
                    onViewAll={() => onChangeTab('', 'All communications')}
                />
            )}
            <Box sx={overviewMainBoxStyle}>
                {(upComingData || leadDetail?.lead_treatments?.length > 0) && <Box sx={overviewLeftLayoutBoxStyle}>
                    {upComingData && <Card sx={{ p: 2, mb: 2, borderRadius: 2, border: '1px solid', borderColor: 'divider', boxShadow: 'none' }} >
                        <Box
                            key={upComingData?.id}
                            sx={{ display: 'flex', width: '100%' }}
                        >
                            <Box sx={{ minWidth: '20px', mt: '0' }}>
                                <Tooltip title={markComplete ? 'Mark as incomplete' : 'Mark as complete'} placement='bottom' TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                                    <Radio
                                        checked={markComplete}
                                        onClick={() => markCompleteBtn(upComingData?.id)}
                                        name='radioButtons'
                                        sx={{ p: 1, '.MuiSvgIcon-root': { width: '24px', height: '24px' } }}
                                    />
                                </Tooltip>
                            </Box>
                            <Paper
                                onClick={() => sidebarHandler(upComingData)}
                                sx={{
                                    ...paperStyle,
                                    pointerEvents: upComingData?.lead?.is_archive_pending || upComingData?.lead?.archived_at ? 'none' : null
                                }}
                            >
                                <Box sx={messageBox}>
                                    <Box>
                                        <Box sx={{ p: '0 24px 0 0' }}>
                                            {upComingData.title !== '' ? <Box sx={{ fontSize: '16px', lineHeight: '24px' }} ><b>{capitalizeFirstLetter(upComingData?.title)}</b></Box> : getMessage(upComingData?.lead_treatment?.status, upComingData?.lead?.first_name, upComingData?.lead?.last_name, upComingData?.lead_treatment?.treatment, upComingData?.group, upComingData?.method)}
                                        </Box>
                                        <Box
                                            sx={{ ...avatarBox, mb: 0 }}
                                        >
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', mt: '6px' }}>
                                                <Box sx={{ display: 'flex' }} >
                                                    <Box
                                                        sx={{
                                                            color: upComingData?.datetime_human.includes('now' || 'NOW') ? common.lightGreen : common.red,
                                                            ...timeLabel
                                                        }}
                                                    >
                                                        <Iconify icon={'charm:clock-alarm'} width={14} height={14} sx={{ mr: '4px' }} />
                                                        {upComingData?.datetime_human && upComingData?.datetime_human || ''}
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box>
                                        {assigneeData?.length > 0 ?
                                            <Box
                                                sx={avatarInnerBox}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <Tooltip title={getAssignees(upComingData)} placement='bottom' TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
                                                    <Box sx={{ display: 'flex' }}>
                                                        {assigneeData?.slice(0, 2)?.map((assignee, index) => (
                                                            <AssignUserAvatar
                                                                key={index}
                                                                sx={assignUserAvatarStyle}
                                                                src={assignee.user?.avatar || ''}
                                                                name={`${assignee.user?.first_name || ''} ${assignee.user?.last_name || ''}`}
                                                                role={assignee.role}
                                                                onClick={(e) => OpenAssignTask(upComingData, e)}
                                                            />
                                                        ))}
                                                        {assigneeData?.length > 2 && (
                                                            <Box sx={assignLengthStyle} onClick={(e) => OpenAssignTask(upComingData, e)}>
                                                                + {assigneeData?.length - 2}
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </Tooltip>
                                            </Box> :
                                            <Box
                                                sx={unassignedBoxStyle}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <Box onClick={(e) => OpenAssignTask(upComingData, e)} sx={plusIconBox}>
                                                    <Iconify width={16} height={16} icon={'eva:plus-fill'} />
                                                </Box>
                                                <Typography
                                                    component={'p'}
                                                    onClick={(e) => OpenAssignTask(upComingData, e)}
                                                    sx={{ ...unassignTypo, color: isLight ? grey[700] : grey[500] }}
                                                >Unassigned</Typography>
                                            </Box>}
                                    </Box>
                                </Box>
                            </Paper>
                        </Box>
                        {leadReminder?.count > 1 && <Button sx={{ mt: '5px' }} onClick={() => onChangeTab('', 'Tasks')}>
                            ...See more
                        </Button>}
                    </Card>}
                    {leadDetail?.lead_treatments?.length > 0 && <Card sx={{ ...appointmentCardStyle, borderRadius: 2, boxShadow: 'none', border: '1px solid', borderColor: 'divider', p: 2, mb: 2 }}>
                        <UpcomingAppointmentsOverview leadAppointment={leadAppointment} treatmentData={treatmentData} leadDetail={leadDetail} treatments={leadDetail?.lead_treatments} handleReloadAPI={handleReloadAPI} />
                    </Card>}
                    {leadDetail?.lead_treatments?.length > 0 && <Card sx={{ ...appointmentCardStyle, borderRadius: 2, boxShadow: 'none', border: '1px solid', borderColor: 'divider', p: 2, mb: 2 }}>
                        <AttendedAppointmentsOverview leadAppointment={pastAppointment} treatmentData={treatmentData} leadDetail={leadDetail} treatments={leadDetail?.lead_treatments} />
                    </Card>}
                    {/* V2 Attended Checklist — replaces the V1 inline checklist surface.
                        The component self-gates visibility (lead has CONSULTATION_ATTENDED
                        treatment AND a V2 task with applies_to_statuses including
                        CONSULTATION_ATTENDED has cells). Returns null otherwise. */}
                    <AttendedChecklistV2
                        practiceId={practiceId}
                        leadId={leadDetail?.id}
                        leadDetail={leadDetail}
                    />
                    {shouldRenderClinCheck && <Card sx={{ ...appointmentCardStyle, borderRadius: 2, boxShadow: 'none', border: '1px solid', borderColor: 'divider', p: 2, mb: 2 }}>
                        <ClinCheckOverViewTab leadDetail={leadDetail} onChangeTab={onChangeTab} />
                    </Card>}
                </Box>}
                <Box sx={(upComingData || leadDetail?.lead_treatments?.length > 0) ? overviewRightLayoutBoxStyle : { width: '100%' }}>
                    {bookedLeadAppointment?.length > 0 && <Card sx={leadAppointmentCardStyle}>
                        <Box sx={lockIconMainBoxStyle}>
                            <Box sx={lockIconInnerBoxStyle}>
                                <Iconify icon={'ic:baseline-lock'} sx={{ color: '#00A76F' }} width={20} height={20} />
                            </Box>
                        </Box>
                        <Typography sx={{ fontSize: '13px', color: '#00A76F', fontWeight: 600 }}>Appointment booked</Typography>
                        <Typography sx={priceValueTextStyle}>£{treatmentData && treatmentData.price || '0'} Potential value.</Typography>
                        <Typography sx={{ fontSize: '13px', color: common.darkGreenContrast, fontWeight: 500, lineHeight: '18px' }}><span style={typoSpanStyle}>{leadDetail?.lead_treatments?.length > 0 && leadDetail?.lead_treatments?.[0]?.treatment || ''}</span> booked for <span style={typoSpanStyle}>{moment(bookedLeadAppointment && bookedLeadAppointment[0]?.datetime, 'DD/MM/YYYY').format('DD MMM YYYY')}</span> at <span style={typoSpanStyle}>{moment(bookedLeadAppointment && bookedLeadAppointment[0]?.datetime, 'DD/MM/YYYY hh:mm:ss').format('hh:mm a')}</span></Typography>
                        <Button variant='contained' sx={takeDepositButton} onClick={() => handleMenuItems('Take a Payment')}>
                            <Iconify icon={'codicon:arrow-down'} sx={{ mr: 0.5 }} width={16} height={16} /> Take deposit
                        </Button>
                    </Card>}
                    <Card sx={{ p: 2, mb: 2, borderRadius: 2, border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}>
                        <RecentNotes leadDetail={leadDetail} LeadNotes={LeadNotes} />
                    </Card>
                    <Card sx={{ p: 2, display: 'flex', mb: 2, borderRadius: 2, border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}>
                        <Box sx={{ p: 0, bgcolor: 'transparent', width: '100%' }}>
                            <NormalLoading tableData={!activityList && 'No Found'} pageCount={!activityList && 'No Found'} />
                            <Typography sx={sectionTitle}>
                                Timeline
                            </Typography>
                            {/* Filter pills */}
                            <Box sx={timelineFilterWrapper}>
                                {['All', 'System', 'Notes', 'Communication'].map((filterLabel) => (
                                    <Box
                                        key={filterLabel}
                                        sx={timelineFilterChip(timelineFilter === filterLabel)}
                                        onClick={() => setTimelineFilter(filterLabel)}
                                    >
                                        {filterLabel}
                                    </Box>
                                ))}
                            </Box>
                            <Box sx={{ maxHeight: '280px', overflow: 'auto', width: '100%' }}>
                                {(filteredActivities || []).slice(0, 3).map((value, index, arr) => {
                                    const { icon: dotIcon, color: dotColor } = getOverviewActivityIcon(value);
                                    const status = getOverviewEmailStatus(value) || getOverviewWhatsAppStatus(value);
                                    const isLast = index === arr.length - 1;
                                    const rawTitle = value?.data?.data?.message || '';
                                    const title = rawTitle === 'Awaiting Response.' ? 'Awaiting Reply.' : capitalizeFirstLetter(rawTitle);
                                    const dateStr = formatOverviewActivityTime(value.timestamp);
                                    const actorName = `${value?.actor?.first_name || ''} ${value?.actor?.last_name || ''}`.trim();
                                    const additionalNotes = value?.action_object?.additional_notes;
                                    return (
                                        <Box
                                            key={`activity-preview-${index}`}
                                            sx={{
                                                position: 'relative',
                                                display: 'flex',
                                                pb: isLast ? 0 : 1.75,
                                            }}
                                        >
                                            {!isLast && (
                                                <Box sx={{
                                                    position: 'absolute',
                                                    left: 13,
                                                    top: 30,
                                                    bottom: 0,
                                                    width: '1px',
                                                    bgcolor: 'rgba(145,158,171,0.16)',
                                                }} />
                                            )}
                                            <Box sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: '50%',
                                                bgcolor: `${dotColor}1F`,
                                                flexShrink: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                position: 'relative',
                                                zIndex: 1,
                                                mt: '1px',
                                            }}>
                                                <Iconify icon={dotIcon} sx={{ width: 14, height: 14, color: dotColor }} />
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0, ml: 1.5, pt: 0.25 }}>
                                                <Stack direction='row' alignItems='flex-start' spacing={1}>
                                                    <Typography sx={{
                                                        flex: 1,
                                                        minWidth: 0,
                                                        fontSize: '12px',
                                                        fontWeight: 500,
                                                        color: 'text.primary',
                                                        lineHeight: 1.45,
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                    }}>
                                                        {title || '—'}
                                                    </Typography>
                                                    {status && (
                                                        <Tooltip title={buildOverviewStatusTooltip(status)} placement='left' TransitionComponent={Zoom} TransitionProps={{ timeout: 200 }}>
                                                            <Box sx={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: 0.375,
                                                                px: 0.75,
                                                                py: 0.125,
                                                                borderRadius: 0.625,
                                                                bgcolor: `${status.color}14`,
                                                                flexShrink: 0,
                                                            }}>
                                                                <Iconify icon={status.icon} sx={{ width: 11, height: 11, color: status.color }} />
                                                                <Typography sx={{
                                                                    fontSize: '0.65rem',
                                                                    fontWeight: 600,
                                                                    color: status.color,
                                                                    lineHeight: 1,
                                                                    whiteSpace: 'nowrap',
                                                                }}>
                                                                    {status.label}
                                                                </Typography>
                                                            </Box>
                                                        </Tooltip>
                                                    )}
                                                </Stack>
                                                <Stack direction='row' alignItems='center' spacing={0.75} sx={{ mt: 0.5, flexWrap: 'wrap', rowGap: 0.25 }}>
                                                    {actorName && (
                                                        <Stack direction='row' alignItems='center' spacing={0.5}>
                                                            <CustomAvatar
                                                                src={value?.actor?.avatar || GetPracticeAvatar(practiceTreatment, practiceId)[0]?.logo}
                                                                name={value?.actor?.first_name}
                                                                sx={{ width: 16, height: 16, fontSize: '0.55rem' }}
                                                            />
                                                            <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary', fontWeight: 500 }}>
                                                                {actorName}
                                                            </Typography>
                                                        </Stack>
                                                    )}
                                                    {actorName && dateStr && (
                                                        <Box sx={{ width: 2, height: 2, bgcolor: 'text.disabled', borderRadius: '50%' }} />
                                                    )}
                                                    {dateStr && (
                                                        <Typography sx={{ fontSize: '0.65rem', color: 'text.disabled', fontWeight: 500 }}>
                                                            {dateStr}
                                                        </Typography>
                                                    )}
                                                    {additionalNotes && (
                                                        <>
                                                            <Box sx={{ width: 2, height: 2, bgcolor: 'text.disabled', borderRadius: '50%' }} />
                                                            <Tooltip
                                                                title={getNoteDisplayText(additionalNotes)}
                                                                placement='bottom'
                                                                TransitionComponent={Zoom}
                                                                TransitionProps={{ timeout: 200 }}
                                                            >
                                                                <Typography
                                                                    tabIndex={0}
                                                                    aria-label={`Note: ${getNoteDisplayText(additionalNotes)}`}
                                                                    sx={{
                                                                        fontSize: '0.65rem',
                                                                        color: 'text.secondary',
                                                                        fontStyle: 'italic',
                                                                        fontWeight: 500,
                                                                        maxWidth: 160,
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        outline: 'none',
                                                                        '&:focus-visible': {
                                                                            boxShadow: '0 0 0 2px rgba(24,144,255,0.25)',
                                                                            borderRadius: '4px',
                                                                        },
                                                                    }}
                                                                >
                                                                    {parseAINote(additionalNotes) ? '🤖 AI Summary' : `“${capitalizeFirstLetter(additionalNotes).slice(0, 50)}${additionalNotes.length > 50 ? '…' : ''}”`}
                                                                </Typography>
                                                            </Tooltip>
                                                        </>
                                                    )}
                                                </Stack>
                                            </Box>
                                        </Box>
                                    );
                                })}
                                {filteredActivities?.length > 3 && (
                                    <Button sx={{ mt: 1, fontSize: '0.75rem' }} onClick={() => onChangeTab('', 'Timeline')}>
                                        See all activity
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Card>
                </Box>
            </Box>
            <Popper
                sx={{
                    zIndex: 1,
                    margin: '0px 20px !important',
                }}
                open={open}
                anchorEl={anchorRef}
                role={undefined}
                transition
                placement={isDesktop ? 'top' : 'top'}
            >
                {({ TransitionProps }) => (
                    <Grow
                        {...TransitionProps}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={buttonHandleClose} >
                                <MenuList id='split-button-menu' autoFocusItem sx={menuListStyle}>
                                    <MenuItem
                                        key='Attended'
                                        onClick={handleAttenedClick}
                                        sx={overViewMenuItemStyle}
                                    >
                                        <Iconify style={menuItemIcon} width={20} height={20} icon={'akar-icons:check'} /> Attended
                                    </MenuItem>
                                    <MenuItem
                                        key='Failed to attend'
                                        onClick={handleAttenedFailedClick}
                                        sx={overViewMenuItemStyle}
                                    >
                                        <Iconify style={menuItemIcon} width={20} height={20} icon={'ci:close-big'} /> Failed to attend
                                    </MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
            <Dialog open={treatmentCon || cancelTreatment} onClose={popupClose}>
                <DialogTitle sx={{ padding: '40px 40px 0px', textAlign: 'center' }}>Are you sure you want to {treatmentCon ? 'complete the treatment' : 'cancel the treatment'} ?</DialogTitle>
                <DialogActions sx={{ padding: '40px !important', justifyContent: 'center' }}>
                    <Button sx={cancelBtnStyle} onClick={popupClose} >Cancel</Button>
                    <LoadingButton
                        type='submit'
                        variant='contained'
                        loading={isLoader}
                        loadingPosition='start'
                        onClick={apiHandler}
                        sx={{ ...yesBtnStyleForLoader(isLoader) }}
                        disabled={isLoader}
                    >
                        {treatmentCon ? 'Complete treatment' : 'Cancel treatment'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            {openAssignTask && (
                <ClickAwayListener onClickAway={onClickAwayEvent}>
                    <Popper open={openAssignTask} anchorEl={anchorElAssign} transition placement='bottom' sx={{ zIndex: '999999' }}>
                        {({ TransitionProps }) => (
                            <Grow {...TransitionProps}>
                                <Paper sx={{ borderRadius: 2 }}>
                                    <AssignTaskPopup
                                        open={openAssignTask}
                                        onClose={popupClose}
                                        leadDetail={leadDetail}
                                        reminder={reminderId}
                                        assignees={assigneeData?.map((ele) => ele.id)}
                                    />
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </ClickAwayListener>
            )}
            {openFollowLead && <OpenContactLeadPopup
                open={openFollowLead}
                headerButtons
                onClose={handleClose}
                openArchivePopup={onOpenArchiveLead}
                user={leadData}
                steps={leadStep}
                type={'followup'}
                validStep={validStep}
                BookingAttendance={BookingAttendance}
                updateStep={() => setValidStep(!validStep)}
                inputRef={inputRef}
                active={active}
                CreateLeadHeaderData={CreateLeadHeaderData}
                setActive={setActive}
                ContactedCount={leadDetail?.lead_treatments[0]?.lead_contacted_counts?.find(item => item.status === leadDetail?.lead_treatments[0]?.status)?.count || 0}
                setOpenContactFromCall={setOpenContactFromCall}
                showWhatsapp={openContactWhatsapp?.open ? {
                    windowDimension: { width, height },
                    chatScreenData: {
                        name: `${leadDetail?.first_name} ${leadDetail?.last_name}`,
                        phoneNumber: leadDetail?.lead_contact?.phone ?? '',
                        leadId: leadDetail?.id
                    },
                    setChatScreenData: () => { },
                    triggeredFromGrid: true
                } : null}
            />
            }
            {openConsultationAttend && <OpenConsultationPopup
                open={openConsultationAttend}
                headerButtons
                onClose={handleClose}
                user={leadData}
                type={'consultationAttended'}
                inputRef={inputRef}
                CreateLeadHeaderData={CreateLeadHeaderData}
                OpenAssignTask={openAppointmentAssignTaskFuc}
                editDetailHandler={editDetailHandler}
                selectedTreatmentData={currentTreatmentData}
            />
            }
            {openRecordAttend && <OpenAttendedPopup
                open={openRecordAttend}
                headerButtons
                onClose={handleClose}
                user={leadData}
                type={'recordAttended'}
                inputRef={inputRef}
                CreateLeadHeaderData={CreateLeadHeaderData}
                OpenAssignTask={openAppointmentAssignTaskFuc}
                editDetailHandler={editDetailHandler}
                isOverview
            />
            }
            {openUnRecordAttend && <OpenUnAttendedPopup
                open={openUnRecordAttend}
                headerButtons
                onClose={handleClose}
                user={leadData}
                type={'recordUnAttended'}
                inputRef={inputRef}
                CreateLeadHeaderData={CreateLeadHeaderData}
            />
            }
            {openArchiveLead && <ArchivedLeadPopUp
                open={openArchiveLead}
                headerButtons
                onClose={handleArchivedClose}
                user={leadData}
                type={'archiveLead'}
                inputRef={inputRef}
                CreateLeadHeaderData={CreateLeadHeaderData}
            />
            }
            {openAppointmentAssignTask && (
                <ClickAwayListener onClickAway={() => appointmentClickAwayEvent()}>
                    <Popper open={openAppointmentAssignTask} anchorEl={anchorElAssign} transition placement='bottom' sx={{ zIndex: '999999' }}>
                        {({ TransitionProps }) => (
                            <Grow {...TransitionProps}>
                                <Paper sx={{ borderRadius: 2 }}>
                                    <AppointmentAssignTaskPopup
                                        open={openAppointmentAssignTask}
                                        onClose={handleCloseAppointmentAssignee}
                                        user={leadData}
                                        leadId={leadDetail?.id}
                                        type={'leadAssign'}
                                        leadDetail={leadDetail}
                                        reminder={reminderId}
                                        selectedTreatmentData={currentTreatmentData}
                                        assignees={assignees}
                                    />
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </ClickAwayListener>
            )}
            {leadDetailModal &&
                <EditPersonalDetailsPopup
                    open={leadDetailModal}
                    handleClose={closeEditDetails}
                    selectedRow={leadData}
                    type={'editLead'}
                    inputRef={personalDetailPopupRef}
                    title='Edit Details'
                    headerButtons
                />
            }
            {EditTreatment && (
                <TreatmentEditPopover
                    handleReloadAPI={handleReloadAPI}
                    open={EditTreatment}
                    anchorEl={anchorEditTreatment}
                    handleClickAwayLister={handleClickAwayLister}
                    leadId={leadDetail.id}
                    isAddTreatment
                />
            )}
            {templateOpen && (
                <LeadTemplate
                    openEmailCompose={Boolean(templateOpen)}
                    onCloseEmailCompose={handleCloseEmailCompose}
                    practiceId={practiceId}
                    type={'EMAIL'}
                    leadDetail={leadData}
                />
            )}
            <ReusableSidebar
                type='Task-overView'
                getReminderBtn={getReminderBtn}
                overViewbtns={getReminderBtn}
                handleAttendClick={handleAttenedClick}
                handleAttendFailedClick={handleAttenedFailedClick}
                onClose={sidebarCloser}
                data={reminderData}
                open={openSidebar}
            />
        </Stack >
    );
};

Overview.propTypes = {
    leadDetail: PropTypes.object,
    activityList: PropTypes.array,
    onChangeTab: PropTypes.func,
    reloadTaskCounter: PropTypes.func,
    handleLoading: PropTypes.func,
    LeadNotes: PropTypes.array,
    handleMenuItems: PropTypes.func,
    setSelectTreatmentData: PropTypes.object,
    openContactFromCall: PropTypes.bool,
    setOpenContactFromCall: PropTypes.func,
    autoAction: PropTypes.string,
};

export default Overview;